import { useQuery } from "@tanstack/react-query";
import api from "./api";
import { FALLBACK_SERVICES, FALLBACK_INDUSTRIES } from "../data/catalog";

export const useProjects = () =>
  useQuery({
    queryKey: ["projects"],
    queryFn: async () => (await api.get("/projects")).data,
  });

export const useProject = (slug) =>
  useQuery({
    queryKey: ["project", slug],
    queryFn: async () => (await api.get(`/projects/${slug}`)).data,
    enabled: !!slug,
  });

export const useArticles = (category) =>
  useQuery({
    queryKey: ["articles", category],
    queryFn: async () =>
      (await api.get("/articles", { params: category ? { category } : {} })).data,
  });

export const useArticle = (slug) =>
  useQuery({
    queryKey: ["article", slug],
    queryFn: async () => (await api.get(`/articles/${slug}`)).data,
    enabled: !!slug,
  });

// Published catalog items from the CMS; static content is shown while loading and if the API fails.
const useCatalog = (path, fallback) => {
  const q = useQuery({
    queryKey: [path],
    queryFn: async () => (await api.get(`/${path}`)).data,
    placeholderData: fallback,
    retry: 1,
  });
  return Array.isArray(q.data) ? q.data : fallback;
};

export const useServices = () => useCatalog("services", FALLBACK_SERVICES);
export const useIndustries = () => useCatalog("industries", FALLBACK_INDUSTRIES);
